import { render } from "./FileType.vue?vue&type=template&id=4948ce70"
import script from "./FileType.vue?vue&type=script&lang=js"
export * from "./FileType.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gokhankaraca/www/dd3502.gfxh.de/a-schade/jobform/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__